// src/entities/user/api/useCurrentGameProfileQueryIfGameAvailable.ts
import { useConfigContext } from "@entities/game/model/useConfigContext.ts";
import { queries } from "@fxid/openapi-client";
import { getAuthToken } from "@fxid/shared";
import { useQuery } from "@tanstack/react-query";

/**
 * Хук для запроса профиля пользователя в контексте текущей игры.
 * Запрос будет выполнен только в том случае, если:
 * 1. Загружена конфигурация игры (`gameConfig`).
 * 2. В приложении присутствует токен аутентификации.
 */
export const useCurrentGameProfileQueryIfGameAvailable = () => {
	// Используем наш новый централизованный хук
	const { gameConfig } = useConfigContext();
	const authToken = getAuthToken();
	const queryData = queries.profile.get({ Game: gameConfig?.GameSystemName });
	return useQuery({...queryData,enabled: !!authToken});
};
